import { atom } from 'jotai';

import { deviceDetailsAsyncAtom } from './deviceDetailsAsyncAtom';

export const availableRepairsAsyncAtom = atom(async (get) => {
  const selectedDeviceDetails = await get(deviceDetailsAsyncAtom);
  return selectedDeviceDetails?.repairs ?? [];
});
